import StringInput from './inputs/StringInput';
import type { Metadata } from '@/utils/store';

export default function MetaView({
  meta,
  onChange,
}: {
  meta: Metadata;
  onChange: (meta: Metadata) => void;
}) {
  const { surname, rank, serial, unit, location, telephone, extra } = meta;

  return (
    <table className="w-full border-r">
      <tbody>
        <tr>
          <td className="w-[27.5%] border-b text-left text-gray-800">
            <StringInput
              value={extra}
              onChange={value => onChange({ ...meta, extra: value })}
            />
          </td>
          <td className="w-[45%] border-t border-b border-l text-left align-top text-gray-800">
            <span className="print:text-2xs px-1 text-sm text-nowrap uppercase">
              Surname — Nom de famille
            </span>
            <StringInput
              value={surname}
              onChange={value => onChange({ ...meta, surname: value })}
            />
          </td>
          <td className="w-0 border-t border-b border-l text-left align-top text-gray-800">
            <span className="print:text-2xs px-1 text-sm text-nowrap uppercase">
              Rank — Grade
            </span>
            <StringInput
              value={rank}
              onChange={value => onChange({ ...meta, rank: value })}
            />
          </td>
          <td className="border-t border-b border-l text-left align-top text-gray-800">
            <span className="print:text-2xs px-1 text-sm text-nowrap uppercase">
              PRI / SN — CIDP / NM
            </span>
            <StringInput
              value={serial}
              onChange={value => onChange({ ...meta, serial: value })}
            />
          </td>
        </tr>
        <tr>
          <td className="border-t border-b border-l text-left align-top text-gray-800">
            <span className="print:text-2xs px-1 text-sm text-nowrap uppercase">
              Unit — Unité
            </span>
            <StringInput
              value={unit}
              onChange={value => onChange({ ...meta, unit: value })}
            />
          </td>
          <td className="border-t border-b border-l text-left align-top text-gray-800">
            <span className="print:text-2xs px-1 text-sm text-nowrap uppercase">
              Location — Endroit
            </span>
            <StringInput
              value={location}
              onChange={value => onChange({ ...meta, location: value })}
            />
          </td>
          <td
            className="border-t border-b border-l text-left align-top text-gray-800"
            colSpan={2}
          >
            <span className="print:text-2xs px-1 text-sm text-nowrap uppercase">
              Telephone No. — N<sup>o</sup> de téléphone
            </span>
            <StringInput
              value={telephone}
              onChange={value => onChange({ ...meta, telephone: value })}
            />
          </td>
        </tr>
      </tbody>
    </table>
  );
}
